export default Object.freeze({
    Filter: 'Filter',
    OpenFilterOptions: 'Open filter options',
    CloseFilterOptions: 'Close filter options',
    ApplyFilterOptions: 'Apply filter options',
    ClearFilterOptions: 'Clear filter options',
    SelectEventViewType: 'Select the event view type',
    ListView: 'List view',
    CalendarView: 'Calendar view',
    FilterEvents: 'Filter Events',
    Featured: 'Featured',
    FeaturedEvent: 'Featured Event',
    FeaturedEvents: 'Featured Events',
    AllEvents: 'All Events',
    Apply: 'Apply',
    Clear: 'Clear',
    Date: 'Date',
    Tags: 'Tags',
    ChooseADate: 'Choose a date',
    EventDate: 'Event Date',
    EventLocation: 'Event Location',
    EventOrganizer: 'Event Organizer',
    EventTickets: 'Event Tickets',
    EventType: 'Event Type',
    BuyTickets: 'Buy Tickets',
    OrganizedBy: 'Organized by',
    Postponed: 'Postponed',
    Cancelled: 'Cancelled',
    EventPostponedTitle: 'This event is postponed',
    EventCancelledTitle: 'This event is cancelled',
    EventPostponedColon: 'Event Postponed: ',
    EventCancelledColon: 'Event Cancelled: ',
    MonthView: 'Month view',
    WeekView: 'Week view',
    DayView: 'Day view',
    Search: 'Search',
    SearchForEvents: 'Search for events',
    SearchResultsFor: 'Search Results for {{query}}',
    SelectView: 'Select view',
    Previous: 'Previous',
    Next: 'Next',
    TodayColon: 'Today: ',
    PlaceholderImage: 'Placeholder image',
    LoadMoreEvents: 'Load more events',
    NoEventsFound: 'No events found',
    NoEventsFoundFor: 'No events found for {{start}} - {{end}}',
    NoMoreEvents: 'No more events',
    NoResultsFor: 'No results for {{query}}',
    NoTags: 'No tags available',
    AddToMyCalendar: 'Add to my calendar',
    VirtualEvent: 'Virtual Event',
    CopyVirtualEventLink: 'Copy virtual event link',
    Copy: 'Copy',
    CopiedExclamation: 'Copied!',
    CopyError: 'Copy Failed',
    JoinOnline: 'Join Online',
    Related: 'Related',
    AddToRSS: 'Add to RSS',
    OutlookICAL: 'Outlook/iCAL',
    ErrorContactingServerMessage: 'There was an error contacting the calendar server. Please try again.',

    SubmitYourEvent: 'Submit your event',
    FooterSubmitEventMessage: 'To have your event considered for listing on the events calendar, please <a href="">submit here</a>.',
    LocationInfo: 'Location Info',
    Zoom: 'Zoom',
    Free: 'Free',
    currencySymbols: {
        USD: '$',
        CAD: '$',
        EUR: '&euro;',
        GBP: '&pound;',
    },
});